import { render, staticRenderFns } from "./EnquireyBannerTwo.vue?vue&type=template&id=3a980547&scoped=true"
import script from "./EnquireyBannerTwo.vue?vue&type=script&lang=js"
export * from "./EnquireyBannerTwo.vue?vue&type=script&lang=js"
import style0 from "./EnquireyBannerTwo.vue?vue&type=style&index=0&id=3a980547&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a980547",
  null
  
)

export default component.exports